<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item active" aria-current="page">
				<fa-icon [icon]="ac.sectionIcons.licensing" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				Key Search
			</li>
			<!-- <li class="breadcrumb-item active" aria-current="page">
				Search
			</li> -->
			<app-loading-spinner *ngIf="loading || searching"></app-loading-spinner>
		</ol>
	</nav>

	<div class="actions">
		<div class="form-inline">
			<button *ngIf="showAddButton" type="button" class="btn btn-outline-primary me-2"
				[routerLink]="['/' + ac.urls.licensing, 'new']">
				<fa-icon [icon]="['fas', 'plus']" size="sm"></fa-icon>
				<span class="cp-action-button-text">New License Key</span>
			</button>

			<button type="button" class="btn btn-outline-secondary me-2" [routerLink]="['/' + ac.urls.licensing, 'aggregate']"
				ngbTooltip="View Usage Information Across a Set of Keys and/or Host IDs">
				<fa-icon [icon]="['fas', 'binoculars']" size="sm"></fa-icon>
				<span class="cp-action-button-text">Aggregate</span>
			</button>

			<button type="button" class="btn btn-outline-secondary me-2" [routerLink]="['/' + ac.urls.licensing, 'offline']">
				<fa-icon [icon]="['fas', 'lightbulb-slash']" size="sm"></fa-icon>
				<span class="cp-action-button-text">Offline Licenses</span>
			</button>
		</div>
	</div>
</div>

<button (click)="ut.scrollToSpot('top-of-list')" id="top-of-list-button" class="cp-scroll-to-top-end d-none" title="Go to top">
	<fa-icon [icon]="['fas', 'angle-up']"></fa-icon>Top
</button>
<div class="list-wrapper" id="list-page-id" (scroll)="ut.onDivScrollHandler('top-of-list-button', 'list-page-id')">
	<div id="top-of-list"></div>

	<form *ngIf="!loading && theSearchForm" [formGroup]="theSearchForm" class="container m-auto">
		<div class="row ps-2 pe-2">
			<div class="cp-filter-block-4">
				<ng-select [items]="ac.searchablProductSelections" bindValue="value" bindLabel="label" id="productsFilter"
					formControlName="productsFilter" [multiple]="true" placeholder="Product(s)" placement="bottom"
					ngbTooltip="Filter results by one or more key product" [closeOnSelect]="false"
					[ngClass]=" { 'border border-success' : productsFilter.value !=null && productsFilter.value.length > 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="ac.searchableKeyTypesSelections" bindValue="value" bindLabel="label" id="typesFilter"
					formControlName="typesFilter" [multiple]="true" placeholder="Type(s)" placement="bottom"
					ngbTooltip="Filter results by one or more key type" [closeOnSelect]="false"
					[ngClass]=" { 'border border-success' : typesFilter.value !=null && typesFilter.value.length > 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<input type="search" id="keyFilter" formControlName="keyFilter" class="form-control" placeholder="Key(s)" placement="bottom"
					ngbTooltip="Enter one or more (space separated) keys"
					[ngClass]="{ 'border border-success': keyFilter.value != null && keyFilter.value !== '' }" />
			</div>

			<div class="cp-filter-block-4">
				<input type="search" id="hostidFilter" formControlName="hostidFilter" class="form-control" placeholder="Host ID(s)/IP(s)"
					placement="bottom" ngbTooltip="Enter one or more (space separated) host IDs and/or host IPs"
					[ngClass]="{ 'border border-success': hostidFilter.value != null && hostidFilter.value !== '' }" />
			</div>

			<div class="cp-filter-block-4">
				<input type="search" id="textFilter" formControlName="textFilter" class="form-control"
					placeholder="Text - Info/Purpose/Label, Notes & Commercial Notes" placement="bottom"
					ngbTooltip="Text to search for in Info/Purpose/Label, Notes & Commercial Notes fields"
					[ngClass]="{ 'border border-success': textFilter.value != null && textFilter.value !== '' }" />
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="orgTypeSelections" bindValue="value" bindLabel="label" id="orgTypeFilter"
					formControlName="orgTypeFilter" [multiple]="true" placeholder="Organizations Type(s)" placement="bottom"
					ngbTooltip="Filter results by one or more Organizations type" [closeOnSelect]="false"
					[ngClass]=" { 'border border-success' : orgTypeFilter.value !=null && orgTypeFilter.value.length > 0 }">
				</ng-select>
			</div>
		</div>

		<div class="text-center">
			<span (click)="toggleAdvanced()" class="cp-pointer"
				[ngbTooltip]=" (advancedSearchMode ? 'Hide' : 'Show') + ' Advanced Filters'">
				<fa-icon *ngIf="advancedSearchMode" [icon]="['fas', 'plus-square']" size="sm"></fa-icon>
				<fa-icon *ngIf="!advancedSearchMode" [icon]="['fas', 'minus-square']" size="sm"></fa-icon>
				Advanced Filters - {{ advancedCount }} set
			</span>
		</div>

		<div *ngIf="advancedSearchMode" class="row ps-2 pe-2">
			<div class="cp-filter-block-4">
				<ng-select [items]="usageDaySelections" bindValue="value" bindLabel="label" id="reportDays" formControlName="reportDays"
					[multiple]="false" placeholder="Reported in the last..." placement="bottom"
					ngbTooltip="Any activation of this key has reported in (with or without traffic)." (change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : reportDays.value !=null && +reportDays.value !== 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="usageDaySelections" bindValue="value" bindLabel="label" id="usageDays" formControlName="usageDays"
					[multiple]="false" placeholder="Used in the last..." placement="bottom"
					ngbTooltip="Any activation of this key has reported in with non-zero traffic." (change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : usageDays.value !=null && +usageDays.value !== 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="usageDaySelections" bindValue="value" bindLabel="label" id="touchedDays" formControlName="touchedDays"
					[multiple]="false" placeholder="Touched in the last..." placement="bottom"
					ngbTooltip="Touched is if the key was added/updated, an activation was added/updated or any activation reported in."
					(change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : touchedDays.value !=null && +touchedDays.value !== 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="usageDaySelections" bindValue="value" bindLabel="label" id="notTouchedDays"
					formControlName="notTouchedDays" [multiple]="false" placeholder="Not touched in the last..." placement="bottom"
					ngbTooltip="Not touched is if the key was not added/updated, an activation was added/updated or any activation reported in."
					(change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : notTouchedDays.value !=null && +notTouchedDays.value !== 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="usageDaySelections" bindValue="value" bindLabel="label" id="updatedDays" formControlName="updatedDays"
					[multiple]="false" placeholder="Added/Edited in the last..." placement="bottom"
					ngbTooltip="The key was added or edited in the last X days.." (change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : updatedDays.value !=null && +updatedDays.value !== 0 }">
				</ng-select>
			</div>

			<!-- <div class="cp-filter-block-4">
				<ng-select [items]="lpusers" bindValue="id" bindLabel="email" id="userIDs" formControlName="userIDs"
					[multiple]="true" placeholder="Last Touched by..." placement="bottom" [closeOnSelect]="false"
					ngbTooltip="Last user from legacy license portal to either add or update the key">
				</ng-select>
			</div> -->

			<div class="cp-filter-block-4">
				<ng-select [items]="staffSelections" bindValue="id" bindLabel="name" id="zcpTouchedBy" formControlName="zcpTouchedBy"
					[multiple]="true" placeholder="Added/Edited Edited by..." placement="bottom"
					ngbTooltip="User that created the key via this Portal" [closeOnSelect]="false" (change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : zcpTouchedBy.value !=null && +zcpTouchedBy.value !== 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="templateSelections" bindValue="value" bindLabel="label" id="keyTemplateFilter"
					formControlName="keyTemplateFilter" [multiple]="true" placeholder="Key Template(s)" placement="bottom"
					ngbTooltip="Filter results by one or more key templates" [closeOnSelect]="false" (change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : keyTemplateFilter.value !=null && keyTemplateFilter.value.length > 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="accountOwnerSelections" bindValue="id" bindLabel="name" id="acctOwnerIDs" formControlName="acctOwnerIDs"
					[multiple]="true" placeholder="Account Owner(s)" placement="bottom"
					ngbTooltip="Account Owner of Organization linked to key" [closeOnSelect]="false" (change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : acctOwnerIDs.value !=null && acctOwnerIDs.value.length > 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="seSelections" bindValue="id" bindLabel="name" id="techRepIDs" formControlName="techRepIDs"
					[multiple]="true" placeholder="SE/SA/TAM(s)" placement="bottom" ngbTooltip="SE/SA/TAM(s) of Organization linked to key"
					[closeOnSelect]="false" (change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : techRepIDs.value !=null && techRepIDs.value.length > 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="orgSelections" bindValue="value" bindLabel="label" id="orgIDs" formControlName="orgIDs"
					[multiple]="true" placeholder="Organization(s)" placement="bottom"
					ngbTooltip="Filter search results to one or more specific organizations" [closeOnSelect]="false"
					(change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : orgIDs.value !=null && orgIDs.value.length > 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="billingCodeSelections" bindValue="value" bindLabel="label" id="billingCodeFilter"
					formControlName="billingCodeFilter" [multiple]="true" placeholder="Billing Code(s)" placement="bottom"
					ngbTooltip="Filter search results to keys reporting against one or more billing codes" [closeOnSelect]="false"
					(change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : billingCodeFilter.value !=null && billingCodeFilter.value.length > 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="featureChoices" bindValue="value" bindLabel="label" id="orBooleanKeyProperties"
					formControlName="orBooleanKeyProperties" [multiple]="true" placeholder="Keys with any of these features"
					placement="bottom" [closeOnSelect]="false" ngbTooltip="Find keys that have at least one of these features enabled."
					(change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : orBooleanKeyProperties.value !=null && orBooleanKeyProperties.value.length > 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="protocolChoices" bindValue="value" bindLabel="label" id="protocolsFilter"
					formControlName="protocolsFilter" [multiple]="true" placeholder="Protocol traffic type" placement="bottom"
					ngbTooltip="Find keys reporting non-zero traffic in one of these protocols" [closeOnSelect]="false"
					(change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : protocolsFilter.value !=null && protocolsFilter.value.length > 0 }">
				</ng-select>
			</div>

			<!-- <div class="cp-filter-block-4">
				<ng-select [items]="brandChoices" bindValue="value" bindLabel="label" id="brandsFilter" formControlName="brandsFilter"
					[multiple]="true" placeholder="Remote brand" placement="bottom"
					ngbTooltip="Find keys reporting non-zero traffic in one of these brands" [closeOnSelect]="false"
					(change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : brandsFilter.value !=null && brandsFilter.value.length > 0 }">
				</ng-select>
			</div> -->

			<div class="cp-filter-block-4">
				<ng-select [items]="protocolSetSelections" bindValue="value" bindLabel="label" id="protocolSetFilter"
					formControlName="protocolSetFilter" [multiple]="true" placeholder="Linked Protocol Set(s)" placement="bottom"
					ngbTooltip="Filter results where key is linked to selected protocol set(s)" [closeOnSelect]="false"
					(change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : protocolSetFilter.value !=null && protocolSetFilter.value.length > 0 }">
				</ng-select>
			</div>

			<div class="cp-filter-block-4">
				<ng-select [items]="commercialTypeSelections" bindValue="value" bindLabel="label" id="commercialTypeFilter"
					formControlName="commercialTypeFilter" [multiple]="true" placeholder="Commercial Type(s)" placement="bottom"
					ngbTooltip="Filter search results to keys with a specific commercial type" [closeOnSelect]="false"
					(change)="updateAdvancedCount()"
					[ngClass]=" { 'border border-success' : commercialTypeFilter.value !=null && commercialTypeFilter.value.length > 0 }">
				</ng-select>
			</div>

		</div>

		<div class="text-center">
			Special Filters - {{ selectedSpecials.length }} selected
		</div>
		<div class="mb-1 pb-1">
			<div class="text-center cp-wider-width-limit mx-auto">
				<span *ngFor="let o of selectedSpecials; let i = index">
					<span class="cp-tag-13 cp-tag-border cp-pointer mb-1 cp-125" (click)="deselectSpecialFilter(o.value)"
						[ngbPopover]="popupContent" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
						<fa-icon [icon]="ac.actionIcons.clear"></fa-icon>
						{{ o.label }}
					</span>
					<ng-template #popupContent>
						<div class="cp-popover-banner">{{ o.label }}</div>
						<div class="cp-pre-text">{{ o.info}}</div>
						<div class="cp-85">
							Click to Remove
						</div>
					</ng-template>
					{{ ' ' }}
				</span>
			</div>
			<div class="text-center mb-1">
				<button type="button" class="btn btn-sm btn-outline-primary" (click)="openSpecialFilterSelector()">
					<fa-icon [icon]="ac.actionIcons.add"></fa-icon>
					Add Special Filters
				</button>
			</div>
		</div>

		<div class="text-center mb-1" *ngIf="!searching">
			<button class="btn btn-primary" type="button" (click)="doSearch()">
				<fa-icon [icon]="['fas', 'search']"></fa-icon> Search for License Keys
			</button>

			<button *ngIf="showResetButton" class="btn btn-outline-primary ms-1" type="button" (click)="resetForm()">
				Reset Search Parameters
			</button>
		</div>

		<div class="text-center" *ngIf="!searching">
			<button class="btn btn-outline-primary ms-1" type="button" (click)="openSavedSearchPanel()"
				ngbTooltip="Select/Manage Your Saved Searches">
				<fa-icon [icon]="['fas', 'list']"></fa-icon>
				Saved Searches<sup>{{ savedSearches.length }}</sup>
			</button>

			<!-- <button class="btn btn-outline-primary ms-1" type="button" (click)="showSaveForm()"
				ngbTooltip="Save these search settings to run the search again in the future or to use with an automated report">
				<fa-icon [icon]="['fas', 'save']"></fa-icon>
				Save Search
			</button> -->

			<!-- <button *ngIf="savedSearches.length !== 0" class="btn btn-outline-primary ms-1" type="button" (click)="formMode='savedSearches'"
				ngbTooltip="Select/Manage one of your saved searches">
				<fa-icon [icon]="['fas', 'list']"></fa-icon>
				Saved Searches<sup>{{ savedSearches.length }}</sup>
			</button>

			<button class="btn btn-outline-primary ms-1" type="button" data-bs-toggle="modal" data-bs-target="#search-help-modal"
				ngbTooltip="Help info on search fields">
				<fa-icon [icon]="['fas', 'question-circle']"></fa-icon>
			</button> -->

			<!-- <button class="btn btn-outline-primary ms-1" type="button" [routerLink]="['/' + ac.urls.licensing, 'search-filter-info']"
				ngbTooltip="Help info on search fields">
				<fa-icon [icon]="['fas', 'question-circle']"></fa-icon>
			</button> -->


			<!-- <div *ngIf="savedSearches.length > 0" class="text-center small mt-1">
				<select id="savedSearchPicker" class="form-control cp-auto-width mx-auto small" (change)="runSavedSearchFromPicker()">
					<option value="">Run a Saved Search</option>
					<option *ngFor="let savedSearch of savedSearches" [value]="savedSearch.id">
						{{ savedSearch.name }}
					</option>
				</select>
			</div> -->
		</div>
	</form>

	<!-- <div *ngIf="showNoParamsMessage" class="cp-warning-message mt-4">
		You must supply at least one search parameter
	</div> -->

	<!-- stretches panel down enough so that autocomplete popups have space -->
	<!-- <div [ngStyle]="{'display': formMode === 'saveForm' ? '' : 'none' }"
		class="mb-4 mt-2 p-2 border cp-general-width-limit m-auto text-center">
		<form *ngIf="!loading && theSaveForm" [formGroup]="theSaveForm">
			<div class="form-group">
				<input type="text" id="name" formControlName="name" class="form-control" placeholder="Name/label for saved search" />
			</div>

			<div class="form-group">
				<button class="btn btn-primary me-1" type="button" [disabled]="!theSaveForm.valid" (click)="saveSearch()">
					<fa-icon [icon]="['fas', 'check']"></fa-icon> Save
				</button>
				<button class="btn btn-outline-secondary" type="button" (click)="formMode='searchForm'">
					<fa-icon [icon]="['fas', 'times']"></fa-icon> Cancel
				</button>
			</div>
		</form>

		<div *ngIf="savedSearches.length > 0">
			Or overwrite another saved search
			<div *ngFor="let savedSearch of savedSearches" class="border p-2 m-2 text-start">
				<button class="btn btn-primary btn-sm" type="button" (click)="overwriteSavedSearch(savedSearch.id)">
					<fa-icon [icon]="['fas', 'save']"></fa-icon> Overwrite
				</button>
				{{ savedSearch.name }}
			</div>
		</div>
	</div> -->

	<!-- <div [ngStyle]="{'display': formMode === 'savedSearches' ? '' : 'none' }"
		class="mb-4 mt-2 p-2 border cp-general-width-limit m-auto text-center">
		Saved Searches
		<div class="text-center">
			<button class="btn btn-outline-secondary btn-sm" type="button" (click)="formMode='searchForm'">
				<fa-icon [icon]="['fas', 'undo']"></fa-icon> Back to Manual Search
			</button>
		</div>
		<div *ngFor="let savedSearch of savedSearches" class="border p-2 m-2 text-start">
			<span class="float-end" type="button" (click)="deleteSavedSearch(savedSearch.id)">
				<fa-icon [icon]="['fas', 'times-circle']" class="text-danger" ngbTooltip="Delete this saved search">
				</fa-icon>
			</span>
			<button class="btn btn-primary btn-sm" type="button" (click)="runSavedSearch(savedSearch.id)">
				<fa-icon [icon]="['fas', 'search']"></fa-icon> Run Search
			</button>
			{{ savedSearch.name }}
		</div>

	</div> -->

	<div *ngIf="!showResults" style="height:300px"></div>

	<!-- <div *ngIf="showRecentMessage" class="cp-info-message mt-4">Recently Viewed Keys</div> -->
	<div [ngStyle]="{'display': !showResults ? 'none' : '' }">
		<!-- <div *ngIf="maxMessage !== ''" class="cp-warning-message mt-4">{{ maxMessage }}</div> -->

		<div *ngIf="showResults">
			<div class="row justify-content-center my-1">
				<div class="col-auto">
					<!-- style="float: right; text-align: right;" -->
					<div class="fw-bold cp-125 border p-1">
						<span *ngIf="!activations || activations.length === 0" class="text-warning">
							No Keys Found
						</span>
						<span *ngIf="activations && activations.length === 1">
							One Key Found
						</span>
						<span *ngIf="activations && activations.length > 1 && maxMessage === ''">
							{{ activations.length }} Keys Found
						</span>
						<span *ngIf="activations && activations.length > 0 && maxMessage !== ''" class="text-warning">
							{{ maxMessage }}
						</span>
					</div>
				</div>
				<div class="col-auto">
					<button [disabled]="!activations || activations.length === 0 || activations.length > ac.maxAggregateKeys"
						class="btn btn-outline-secondary me-1" type="button" (click)="doAggregate()"
						[ngbTooltip]="'View Aggregate Stats Across All Keys.  Must be ' + ac.maxAggregateKeys + ' keys or less.'"
						placement="end">
						<fa-icon [icon]="['fas', 'binoculars']" size="sm"></fa-icon>
					</button>

					<button [disabled]="!activations || activations.length === 0" class="btn btn-outline-secondary" type="button"
						(click)="saveAsExcel()">
						<fa-icon [icon]="['fas', 'file-excel']"></fa-icon> Export Results
					</button>
				</div>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-auto">
				<app-table-keys #keysTable1></app-table-keys>
			</div>
		</div>
	</div>
</div>


<div class="modal" id="search-help-modal" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-xl modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">
					Help
				</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-search-help-panel">
				</button>
			</div>

			<div class="modal-body">
				<ul class="cp-nav-tabs" id="myTab" role="tablist">
					<li class="cp-nav-item" role="presentation">
						<button type="button" class="cp-nav-tab-link cp-std-tab active" data-bs-toggle="tab" role="tab" aria-selected="true"
							id="nav-basic-tab" aria-controls="nav-basic" data-bs-target="#nav-basic">
							Basic Filters
						</button>
					</li>

					<li class="cp-nav-item" role="presentation">
						<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
							id="nav-advanced-tab" aria-controls="nav-advanced" data-bs-target="#nav-advanced">
							Advanced Filters
						</button>
					</li>

					<li class="cp-nav-item" role="presentation">
						<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
							id="nav-special-tab" aria-controls="nav-special" data-bs-target="#nav-special">
							Special Filters
						</button>
					</li>

					<li class="cp-nav-item" role="presentation">
						<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
							id="nav-protocols-tab" aria-controls="nav-protocols" data-bs-target="#nav-protocols">
							Protocols
						</button>
					</li>
				</ul>

				<div class="tab-content" id="nav-tabContent">
					<div class="tab-pane show active" id="nav-basic" role="tabpanel" aria-labelledby="nav-basic-tab">
						<div class="cp-general-width-limit">
							<div class="mb-1">
								<div class="fw-bold">Product(s)</div>
								<div class="ms-2">
									Zixi Broadcaster (all three sub-products), Zixi Feeder, Zixi Receiver, etc.<br />
									Some legacy products (encoder_feeder, accept, metered_broadcaster, ramp_client ) are not
									included in filter list. Keys with these products can still be found using other filters.
								</div>
							</div>

							<div *ngIf="keyTypes && keyTypes.length > 0" class="mb-1">
								<div class="fw-bold">Type(s)</div>
								<div class="ms-2">
									{{ keyTypes.join(', ') }}
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Key(s)</div>
								<div class="ms-2">
									Supports multiple space-separated search terms.<br />
									Can be full or partial key.
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Host ID(s)/IP(s)</div>
								<div class="ms-2">
									Supports multiple space-separated search terms.<br />
									Searches for keys that have activations with a matching host ID or IP.
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Text – {{ ac.keyInfoFieldLabel }} & Notes</div>
								<div class="ms-2">
									Searches both the {{ ac.keyInfoFieldLabel }} (used to be labeled "Customer"), Notes
									and Commercial Notes
									fields for any instance of the word(s) specified.<br />
									Putting a quote (”) at the beginning and end will force an exact match and not break text into
									words.
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Organization Type(s)</div>
								<div class="ms-2">
									If a license key is linked to a portal organization, filter results based on the
									organization’s type.
								</div>
							</div>
						</div>
					</div>

					<div class="tab-pane" id="nav-advanced" role="tabpanel" aria-labelledby="nav-advanced-tab">
						<div class="cp-general-width-limit">
							<div class="mb-1">
								<div class="fw-bold">Reported In The Last…</div>
								<div class="ms-2">
									Find Keys that either/or:<br />
									- Have reported in (zero or non-zero bytes) against a meter<br />
									- Have reported protocol (v13+) traffic (zero or non-zero bytes) in the last X days
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Used In The Last…</div>
								<div class="ms-2">
									Find Keys that either/or:<br />
									- Have reported usage (non-zero bytes) against a meter<br />
									- Have reported protocol (v13+) usage (non-zero bytes) in the last X days
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Touched In The Last…</div>
								<div class="ms-2">
									Find Keys that either/or:<br />
									- Have been added or updated in the last X days<br />
									- Have new activations in the last X days<br />
									- Have reported traffic (zero or non-zero bytes) against a meter<br />
									- Have reported protocol (v13+) traffic (zero or non-zero bytes) in the last X days
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Not Touched In The Last…</div>
								<div class="ms-2">
									Find Keys that:<br />
									- Have not been added or updated in the last X days<br />
									- No new activations in the last X days<br />
									- Have not reported traffic (zero or non-zero bytes) against a meter<br />
									- Have not reported protocol (v13+) traffic (zero or non-zero bytes) in the last X days
								</div>
							</div>

							<!-- <div class="mb-1">
					<div class="fw-bold">Last Touched By…</div>
					<div class="ms-2">
						Legacy users from the previous generation License Portal.<br />
						Keys record the user that either created the key or last edited the key.
					</div>
				</div> -->

							<div class="mb-1">
								<div class="fw-bold">Added/Edited in the Last...</div>
								<div class="ms-2">
									Find keys that were added or last edited in the last X days.
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Added/Edited by...</div>
								<div class="ms-2">
									Find keys created and/or last edited by selected ZCP user(s).
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Key Template(s)</div>
								<div class="ms-2">
									What template (the basis for what the key can/cannot do) was used tcreate the key.
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Account Owner(s)</div>
								<div class="ms-2">
									If a license key is linked to a portal organization, filter results based on the
									organization’s account owner (which is account owner from Salesforce).
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">SE/SA/TAM(s)</div>
								<div class="ms-2">
									If a license key is linked to a portal organization, filter results based on the
									organization’s SE/SA/TAM(s).
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Organization(s)</div>
								<div class="ms-2">
									If a license key is linked to one of these portal organizations.
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Billing Code(s)</div>
								<div class="ms-2">
									If a license has reported usage using one of these billing codes.
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Protocol Traffic Type</div>
								<div class="ms-2">
									Find Keys that have reported non-zero byte traffic of the protocol(s) selected (will only work
									with keys that have at least one Broadcaster v13 or later)
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Keys With All Of These Features</div>
								<div class="ms-2">
									Find Keys that have been configured with all selected features enabled.
								</div>
							</div>

							<!-- <div class="mb-1">
					<div class="fw-bold">Keys With All Of These Features</div>
					<div class="ms-2">
						Find Keys that have been configured with any (1 or more) selected features enabled.
					</div>
				</div> -->

							<div class="mb-1">
								<div class="fw-bold">Linked Protocol Set(s)</div>
								<div class="ms-2">
									Find keys that are linked to selected protocol set(s)
								</div>
							</div>

							<div class="mb-1">
								<div class="fw-bold">Commercial Type(s)</div>
								<div class="ms-2">
									Find Keys that have the selected commercial type(s) set.
								</div>
							</div>

						</div>
					</div>

					<div class="tab-pane" id="nav-special" role="tabpanel" aria-labelledby="nav-special-tab">
						<div class="cp-general-width-limit">
							<div *ngFor="let o of ac.specialKeySearches; let i = index" class="mb-1">
								<div class="fw-bold">{{ o.label }}</div>
								<div *ngIf="o.info && o.info !== ''" class="ms-2">
									{{ o.info }}
								</div>
							</div>
						</div>
					</div>

					<div class="tab-pane" id="nav-protocols" role="tabpanel" aria-labelledby="nav-protocols-tab">
						<div class="container">

							<div class="row">
								<div *ngFor="let protocolBlock of protocolBlocks; let i = index" class="col-auto">
									<div class="fw-bold cp-pre-text">
										{{ protocolBlock.label }}
									</div>
									<ul class="ps-4">
										<li *ngFor="let protocol of protocolBlock.protocols; let i = index">
											{{ protocol }}
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>

				</div>



			</div>
		</div>
	</div>
</div>

<button type="button" [hidden]="true" id="open-special-filters-panel" data-bs-toggle="offcanvas" data-bs-target="#special-filters-panel"
	aria-controls="special-filters-panel">
</button>
<div class="offcanvas offcanvas-end cp-wide-off-canvas" tabindex="-1" id="special-filters-panel"
	aria-labelledby="special-filters-panel-label">
	<div class="offcanvas-header border p-2 ps-3">
		<h5 class="offcanvas-title" id="special-filters-panel-label">
			Available Special Filters
		</h5>
		<button type="button" class="btn-close" id="close-protocol-sets-panel" data-bs-dismiss="offcanvas" aria-label="Close"></button>
	</div>
	<div class="offcanvas-body border p-2">
		<table class="mx-auto table table-striped table-hover cp-auto-width">
			<tr *ngFor="let o of deselectedSpecials; let i = index">
				<td>
					<button type="button" class="btn btn-outline-primary btn-sm" (click)="selectSpecialFilter(o.value)"
						[ngbPopover]="popupContent" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
						<fa-icon [icon]="['fas', 'plus']" size="sm"></fa-icon>
					</button>
				</td>
				<td>
					<span class="cp-110" [ngbPopover]="popupContent" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
						container="body">
						<fa-icon *ngIf="o.info && o.info !== ''" [icon]="['fas', 'question-circle']" size="sm"></fa-icon>
						{{ o.label }}
					</span>
				</td>
				<ng-template #popupContent>
					<div class="cp-popover-banner">{{ o.label }}</div>
					<div class="cp-pre-text">{{ o.info}}</div>
				</ng-template>
			</tr>
		</table>

	</div>
</div>

<button type="button" [hidden]="true" id="open-saved-search-panel" data-bs-toggle="offcanvas" data-bs-target="#saved-search-panel"
	aria-controls="saved-search-panel">
</button>
<div class="offcanvas offcanvas-end cp-wide-off-canvas" tabindex="-1" id="saved-search-panel" aria-labelledby="saved-search-panel-label">
	<div class="offcanvas-header border p-2 ps-3">
		<h5 class="offcanvas-title" id="saved-search-panel-label">
			Save Searches
		</h5>
		<button type="button" class="btn-close" id="close-saved-search-panel" data-bs-dismiss="offcanvas" aria-label="Close"></button>
	</div>
	<div class="offcanvas-body border p-2">
		<form *ngIf="!loading && theSaveForm" [formGroup]="theSaveForm" class="mb-3">
			<div class="text-center">
				You can save these search parameters if you think you'll neeed to run the same search later and/or you'd like to setup a
				regular e-mail notification.
			</div>

			<div class="form-group">
				<input type="text" id="name" formControlName="name" class="form-control" placeholder="Name/label for saved search" />
			</div>

			<div *ngIf="saveSearchWarnings.length > 0" class="cp-danger-message">
				<div *ngFor="let w of saveSearchWarnings">
					{{ w }}
				</div>
			</div>

			<div class="form-group" class="text-center">
				<button class="btn btn-primary me-1" type="button" [disabled]="!theSaveForm.valid" (click)="saveSearch()">
					<fa-icon [icon]="['fas', 'check']"></fa-icon> Save Search Parameters
				</button>
			</div>
		</form>

		<table class="mx-auto table table-striped table-hover cp-auto-width">
			<tbody>
				<tr *ngFor="let savedSearch of savedSearches">
					<td class="cp-icon-cell">
						<button class="btn btn-outline-primary btn-sm" type="button" (click)="runSavedSearch(savedSearch.id)">
							<fa-icon [icon]="['fas', 'search']"></fa-icon> Run Search
						</button>
					</td>
					<td class="cp-110">
						<fa-icon *ngIf="savedSearch['__notify']" [icon]="ac.sectionIcons.mynotifications"
							ngbTooltip="This saved search is setup for notifications"></fa-icon>
						{{ savedSearch.name }}
					</td>
					<td>
						<button class="btn btn-outline-primary btn-sm" type="button" (click)="overwriteSavedSearch(savedSearch.id)"
							[disabled]="!atLeastOneSearchParam">
							<fa-icon [icon]="['fas', 'save']"></fa-icon> Overwrite
						</button>
					</td>
					<td class="cp-icon-cell">
						<span type="button" class="btn btn-sm btn-outline-danger" (click)="deleteSavedSearch(savedSearch.id)">
							<fa-icon [icon]="ac.actionIcons.delete" class="text-danger" ngbTooltip="Delete this saved search">
							</fa-icon>
						</span>
					</td>
				</tr>
			</tbody>
		</table>

		<!-- <div *ngFor="let savedSearch of savedSearches" class="border p-2 m-2 text-start">
			<span class="float-end" type="button" (click)="deleteSavedSearch(savedSearch.id)">
				<fa-icon [icon]="['fas', 'times-circle']" class="text-danger" ngbTooltip="Delete this saved search">
				</fa-icon>
			</span>
			<button class="btn btn-primary btn-sm" type="button" (click)="runSavedSearch(savedSearch.id)">
				<fa-icon [icon]="['fas', 'search']"></fa-icon> Run Search
			</button>
			{{ savedSearch.name }}
		</div>
 -->

	</div>
</div>